import { apiservice } from "../service/service";
export async function getmission(token) {
  try {
    const response = await apiservice({
      path: "/event/getallmission",
      method: "get",
      token: token?.accessToken,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getup(token) {
  try {
    const response = await apiservice({
      path: "/event/getallrankup",
      method: "get",
      token: token?.accessToken,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getevent(token) {
  try {
    const response = await apiservice({
      path: "/event/getallevent",
      method: "get",
      token: token?.accessToken,
    });
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getCoupons(token, page = 1, limit = 10) {
  try {
    const response = await apiservice({
      path: `/admin/coupons?offset=${page}&limit=${limit}`,
      method: "get",
      token: token?.accessToken,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
